import { useParams } from "react-router"
import { useQuery } from "react-query"
import { useShopify } from "../../components/ShopifyProvider"

export function useProduct() {
  const { handle } = useParams()
  if (handle === undefined) throw new Error("No handle")

  const sdk = useShopify()
  const { data } = useQuery(`product_${handle}`, () => sdk.product({ handle }))

  return data?.productByHandle ?? null
}
